var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
  'padding-bottom': !_vm.$vuetify.breakpoint.mdAndUp  ? '56px' : 'initial',
})},[(_vm.detailView)?_c('list-navigator',{style:({
      zIndex: _vm.$vuetify.breakpoint.mdAndUp ? 'initial': '10',
    }),attrs:{"backButtonHref":"/notifs","disabled":_vm.detailViewData.loading,"total":_vm.listViewData.items.length,"current":_vm.currentItemIndex},on:{"navigate":(idx) => _vm.viewItemDetails(idx)}}):_vm._e(),_c('router-view',_vm._b({on:{"request":_vm.request}},'router-view',_vm.viewData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }